import { SvgIconType } from './svg.interface';

const UserAvatar: SvgIconType = ({
  width = 80,
  height = 80,
  className = '',
  square = false,
  color = '#3AA5DC'
}) => (
  <>
    {!square ? (
      <svg
        width={width}
        height={height}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <circle cx="40" cy="40" r="40" fill={color} />
        <path
          d="M40.5886 16H39.4114C39.1204 16 38.8294 16.0121 38.5394 16.0363C32.7605 16.5178 28.4661 21.593 28.9477 27.372L29.4403 33.2837C29.898 38.7757 34.489 43 40 43C45.511 43 50.102 38.7757 50.5597 33.2837L51.0523 27.372C51.0765 27.0819 51.0886 26.791 51.0886 26.5C51.0886 20.701 46.3876 16 40.5886 16Z"
          fill="white"
        />
        <path
          d="M51.7004 44.3877C48.6317 47.2527 44.5135 49 40 49C35.4865 49 31.3683 47.2527 28.2996 44.3877L23.0225 46.3666C18.7984 47.9506 16 51.9887 16 56.5V61C16 62.6569 17.3431 64 19 64H61C62.6569 64 64 62.6569 64 61V56.5C64 51.9887 61.2016 47.9506 56.9775 46.3666L51.7004 44.3877Z"
          fill="white"
        />
      </svg>
    ) : (
      <>
        <svg
          width={width}
          height={height}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="32" height="32" rx="6" fill={color} />
          <path
            d="M16.1962 7.99902H15.8038C15.7068 7.99902 15.6098 8.00306 15.5131 8.01111C13.5868 8.17164 12.1554 9.86336 12.3159 11.7897L12.4801 13.7602C12.6327 15.5909 14.163 16.999 16 16.999C17.837 16.999 19.3673 15.5909 19.5199 13.7602L19.6841 11.7897C19.6922 11.693 19.6962 11.596 19.6962 11.499C19.6962 9.56603 18.1292 7.99902 16.1962 7.99902Z"
            fill="white"
          />
          <path
            d="M19.9001 17.4616C18.8772 18.4166 17.5045 18.999 16 18.999C14.4955 18.999 13.1228 18.4166 12.0999 17.4616L10.3408 18.1212C8.9328 18.6492 8 19.9953 8 21.499V22.999C8 23.5513 8.44772 23.999 9 23.999H23C23.5523 23.999 24 23.5513 24 22.999V21.499C24 19.9953 23.0672 18.6492 21.6592 18.1212L19.9001 17.4616Z"
            fill="white"
          />
        </svg>
      </>
    )}
  </>
);

export default UserAvatar;
